import React, { Fragment, memo } from 'react'
import PropTypes from 'prop-types'
import { Label } from '../../components'
import { CHECKBOX, RADIOBUTTONS, RADIOBUTTONS_GRID, SWITCH } from '../../config'

const TrueFalse = ({
  id,
  name,
  helpText,
  label,
  style,
  checked,
  defaultValue,
  context,
  onChange,
  unlabeled,
}) => {
  const htmlFor = id
  if (unlabeled) {
    helpText = null
    label = null
  }
  switch (style) {
    case CHECKBOX:
      return (
        <div className="form-check mt-2">
          <input className="form-check-input" type="checkbox"
                 id={id}
                 onChange={e => {
                   onChange(e.target.checked)
                 }}
                 checked={checked}
                 defaultChecked={defaultValue === 'true'}
          />
          <Label name={name} label={label} className="form-check-label"
                 helpText={helpText} forId={htmlFor}/>
        </div>
      )

    case SWITCH:
      return (
        <div className="custom-control custom-switch">
          <input type="checkbox" className="custom-control-input" id={id}
                 onChange={e => onChange(e.target.checked)}
                 checked={checked}
                 defaultChecked={defaultValue === 'true'}
          />
          <Label name={name} label={label} forId={htmlFor} helpText={helpText}
                 className="custom-control-label"/>
        </div>
      )

    case RADIOBUTTONS:
      return (
        <Fragment>
          <Label name={name} label={label} forId={''}
                 className="form-check-label" helpText={helpText}/>
          <div className="custom-control custom-radio mt-1">
            <input type="radio" id={id + '|true'} name={id}
                   className="custom-control-input"
                   checked={checked}
                   defaultChecked={defaultValue === 'true'}
                   onChange={() => onChange(true)}/>
            <label className="custom-control-label"
                   htmlFor={id + '|true'}>Yes</label>
          </div>
          <div className="custom-control custom-radio">
            <input type="radio" id={id + '|false'} name={id}
                   className="custom-control-input"
                   checked={(typeof checked === 'boolean') && !checked}
                   defaultChecked={defaultValue === 'false'}
                   onChange={() => onChange(false)}/>
            <label className="custom-control-label"
                   htmlFor={id + '|false'}>No</label>
          </div>
        </Fragment>
      )

    case RADIOBUTTONS_GRID:
      return (
        <Fragment>
          <Label name={name} label={label} forId={''}
                 className="form-check-label" helpText={helpText}/>
          <div className="d-flex">
            <div
              className="custom-control custom-radio custom-control-inline mt-1">
              <input type="radio" id={id + '|true'} name={id}
                     className="custom-control-input"
                     checked={checked}
                     defaultChecked={defaultValue === 'true'}
                     onChange={() => onChange(true)}/>
              <label className="custom-control-label"
                     htmlFor={id + '|true'}>Yes</label>
            </div>
            <div
              className="custom-control custom-radio custom-control-inline mt-1">
              <input type="radio" id={id + '|false'} name={id}
                     className="custom-control-input"
                     checked={(typeof checked === 'boolean') && !checked}
                     defaultChecked={defaultValue === 'false'}
                     onChange={() => onChange(false)}/>
              <label className="custom-control-label"
                     htmlFor={id + '|false'}>No</label>
            </div>
          </div>
        </Fragment>
      )

    default:
      return null
  }
}

TrueFalse.propTypes = {
  style: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  defaultValue: PropTypes.string,
  checked: PropTypes.bool,
}

export default memo(TrueFalse)
